// angular.module('percentFilter', [])
angular.module('Filters')
.filter('percentage', ['$filter', function ($filter) {
  return function (input, decimals) {

  	decimals = decimals ? decimals : 2;

    return $filter('number')(input * 100, decimals) + '%';
  };
}]);